import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
	selector: 'app-promo-stacks-banner',
	templateUrl: './promo-stacks-banner.component.html',
	styleUrls: ['./promo-stacks-banner.component.scss'],
})
export class PromoStacksBannerComponent {
	@Input() user;

	constructor(
		private router: Router,
	) { }

	promosStacks() {
		if (this.user) {
			this.router.navigate([`/author-dashboard/${this.user.authorLink}/promo-stacks`]).then();
			return;
		}

		this.router.navigate(['/promo-stacks']).then();
	}
}
